import { styled, Box } from '@creditas-ui/react';

const IconButton = styled(Box.withComponent('a'))`
  background: white;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { IconButton };
